import React, { Component } from 'react';
import ComponentContainer from 'containers/ComponentContainer';
import SingleSignOnModal from './SingleSignOnModal';
import LoginWeb from './LoginWeb';
import LoginMobile from './LoginMobile';
import signInService from 'services/SignInService';
import { SignInResultType } from 'services/EnumConstants';
import { EmailValidation } from 'services/EnumConstants';
import 'extensions/urlSearchParamsExtensions';

const PASSWORD_FIELD = "password";

export default class LoginWrapper extends Component {
    state = {
        openSsoModal: false,
        sso: undefined,
        loading: true,
        returnUrl: '',
        email: '',
        password: '',
        resendActivationEmailVisible: false,
        resendActivationToken: '',
        resendActivationUserId: '',
        provider: undefined
    };

    render() {
        const { loginConfig } = this.props;
        
        return (
            <ComponentContainer loading={this.state.loading}>
            {(props) => {
                    this.parentProps = props;
                    return (
                        <div>
                            {loginConfig.formType === 'web' ? 
                                <LoginWeb
                                    onSubmit={this.handleSubmit}
                                    onEmailChanged={this.handleEmailChanged}
                                    onPropsChange={this.handlePropsChange}
                                    onSendActivationEmail={this.handleSendActivationEmail}
                                    data={this.state}
                                    loginConfig={loginConfig || {}}
                                    onHandleGoogle={this.handleGoogle}
                                    onHandleFacebook={this.handleFacebook}
                                    onHandleMicrosoft={this.handleMicrosoft}
                                    onHandleApple={this.handleApple}
                                    onSsoClick={this.handleSso} />
                            :
                                <LoginMobile
                                    onSubmit={this.handleSubmit}
                                    onEmailChanged={this.handleEmailChanged}
                                    onPropsChange={this.handlePropsChange}
                                    onSendActivationEmail={this.handleSendActivationEmail}
                                    data={this.state}
                                    loginConfig={loginConfig || {}}
                                    onHandleGoogle={this.handleGoogle}
                                    onHandleFacebook={this.handleFacebook}
                                    onHandleMicrosoft={this.handleMicrosoft}
                                    onHandleApple={this.handleApple}
                                    onSsoClick={this.handleSso}
                                    intl={this.parentProps.intl}/>
                            }
                            <SingleSignOnModal open={this.state.openSsoModal} sso={this.state.sso} provider={this.state.provider} />
                        </div>
                    );
                }}
            </ComponentContainer>
        );
    }

    handleSso = async () => {
        var mmm = "@mmm.com";
        var sso = this.singleSignOn.find(ss => mmm.endsWith(ss.emailDomain));

        this.setState({
            openSsoModal: true,
            sso
        });

        var provider = sso.provider ? sso.provider : 'aad';
        setTimeout(() => this.navigateToSingleSignOn(provider), 1000);
    }

    handleGoogle = () => {
        this.goToExternalLogin('Google');
    }

    handleFacebook = () => {
        this.goToExternalLogin('Facebook');
    }

    handleMicrosoft = () => {
        this.goToExternalLogin('Microsoft');
    }

    handleApple = () => {
        this.goToExternalLogin('Apple');
    }

    goToExternalLogin = (provider) => {
        var returnUrl = this.state.returnUrl;
        var encodedReturnUrl = '/';
        if (returnUrl) {
            encodedReturnUrl = returnUrl.replace(/&/g, '%26');
        }
        window.location.href = '/External/Challenge?provider=' + provider + '&returnUrl=' + encodedReturnUrl;
    }

    handleEmailChanged = async (e) => {
        var email = e.target.value.toLowerCase();
        if (!this.singleSignOn) {
            return;
        }

        var sso = this.singleSignOn.find(ss => email.endsWith(ss.emailDomain));

        if (sso) {
            this.setState({
                openSsoModal: true,
                sso
            });

            var ssoProvider = sso.provider ? sso.provider : 'aad';
            setTimeout(() => this.navigateToSingleSignOn(ssoProvider), 1000);
        } else {
            // make sure this is a valid email before checking to see if it is linked to a provider
            if (email.toLowerCase().match(EmailValidation.Production)) {
                var provider = await this.getEmailProvider(email);
                if (provider) {
                    this.setState({
                        openSsoModal: true,
                        provider
                    });

                    setTimeout(() => this.navigateToSingleSignOn(provider), 1000);
                }
            }
        }
    }

    navigateToSingleSignOn = (provider) => {
        var returnUrl = this.state.returnUrl;
        var encodedReturnUrl = '/';
        if (returnUrl) {
            encodedReturnUrl = returnUrl.replace(/&/g, '%26');
        }
        window.location.href = '/External/Challenge?provider=' + provider + '&returnUrl=' + encodedReturnUrl;
    }

    handleSubmit = (values, props) => {
        const { setSubmitting, setValues } = this.signInProps;
        setSubmitting(true);

        // reset all the error states
        setValues({
            ...values,
            logInErrorId: undefined,
            resendActivationEmailVisible: undefined,
            resendActivationToken: undefined,
            resendActivationUserId: undefined
        }, false);

        signInService
            .signIn(values, this.state.returnUrl)
            .then((result) => this.signInCompleted(result, values, props))
            .finally(() => setSubmitting(false));
    };

    handleSendActivationEmail = () => {
        const { setValues, setFieldValue } = this.signInProps;
        const { resendActivationUserId } = this.signInProps.values;
        if (resendActivationUserId) {
            setValues({
                ...this.signInProps.values,
                resendActivationEmailFailed: false,
                resendActivationEmailSuccessful: false,
                resendActivationEmailInProgress: true
            });

            signInService.resendActivationEmail(resendActivationUserId, this.state.returnUrl)
                .then(() => setFieldValue('resendActivationEmailSuccessful', true))
                .catch(() => setFieldValue('resendActivationEmailFailed', true))
                .finally(() => setFieldValue('resendActivationEmailInProgress', false));
        }
    };

    handlePropsChange = (props) => {
        this.signInProps = props;
    };

    signInCompleted = (result, values, props) => {
        const { setFieldValue } = this.signInProps;
        var resultTypeCode = result.result;
        var signInError;

        switch (resultTypeCode) {
            case SignInResultType.AccountNeedsConfirmation:
                this.showAccountNeedsConfirmation(result, values, props);
                break;
            case SignInResultType.LockedOut:
                signInError = 'logIn.lockedOut';
                break;
            case SignInResultType.WrongCredentials:
                signInError = 'logIn.wrongCredentials';
                this.hardResetValue(PASSWORD_FIELD, "");
                break;
            case SignInResultType.AccountInactivated:
                signInError = 'logIn.accountInactivated';
                this.hardResetValue(PASSWORD_FIELD, "");
                break;
            case SignInResultType.NoRoles:
                signInError = 'logIn.notAForesightUser';
                break;
            case SignInResultType.NeedsToRegister:
                window.location.replace(result.registrationRedirectUri);
                break;
            case SignInResultType.Success:
                window.location.replace(result.validatedRedirectUri);
                break;
            default:
                console.warn(`Invalid SignInResultType of ${resultTypeCode}`);
        }

        setFieldValue('logInErrorId', signInError);
    };

    hardResetValue = (fieldName, value) => {
        // To trigger form validation and show an error message (did not work in Safari),
        // we need to set the field value to empty in this way, as a workaround.
        // see GitHub issue https://github.com/jaredpalmer/formik/issues/2059

        this.signInProps.values[fieldName] = value;
    }

    showAccountNeedsConfirmation = (result, values, props) => {
        const { setValues } = props;

        setValues({
            ...values,
            ...result,
            resendActivationEmailVisible: true
        }, false);
    };

    componentDidMount() {
        this.getSingleSignOns();
        const params = new URLSearchParams(window.location.search);
        const returnUrl = params.getIgnoreCase('ReturnUrl');
        const result = parseInt(params.getIgnoreCase('result'));
        let errorId = null;
        if (result) {
            if (result === SignInResultType.InvalidSocialUserName) {
                errorId = 'logIn.invalidSocialUserName';
            } else if (result === SignInResultType.AccountNeedsConfirmation) {
                errorId = 'logIn.externalAccountConfirmation';
            }
        }

        this.setState({ loading: false, returnUrl, socialLogInErrorId: errorId });
    }

    async getSingleSignOns() {
        this.singleSignOn = await signInService.getSingleSignOns();
    }

    async getEmailProvider(email) {
        var provider = await signInService.getEmailProvider(email);
        return provider;
    }
}
